import { useEffect, useState, useTransition } from "react";

/** Reveals the (client-only) Lottie a beat after mount so SSR paints the static
 *  SVG first, then crossfades. */
export function useLottieLoader(delay = 100) {
  const [showLottie, setShowLottie] = useState(false);
  const [, startTransition] = useTransition();

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      startTransition(() => setShowLottie(true));
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [delay]);

  return { showLottie };
}
